import React from 'react';
import Icon from 'Core/Components/Icon';

import { dismissError } from 'RLX/State/Ui/UiActions';

class ErrorView extends React.Component {
  constructor (props) {
    super(props);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  componentDidMount () {
    window.addEventListener('keydown', this.props.onDismiss)
  }

  componentWillUnmount () {
    window.removeEventListener('keydown', this.props.onDismiss)
  }

  render () {
    const { message, style, onDismiss } = this.props;
    return (
      <div className="ErrorView" style={style ? style : {}}>
        <img src="assets/logo-white.svg" className="Main-Logo" />
        <h2><Icon fa="times-circle" /> &nbsp; FATAL ERROR</h2>
        <div>
          {message || <big><em>Whoops!</em> Something went wrong. &nbsp; 🙃</big>}
        </div>
        {!onDismiss ? null : (
          <button type="button" onClick={onDismiss}>
            <Icon fa="hand-o-left left" /> Dismiss
          </button>
        )}
      </div>
    );
  }
};

export default ErrorView;



// WEBPACK FOOTER //
// ./client/Core/Status/ErrorView.jsx